import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, isRef as _isRef, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }

import useValidation from 'SharedDir/common/composables/useValidation';
import { computed, toValue } from 'vue';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { FieldParameter } from 'SharedDir/declarations/fields';
import TextParameter from 'SharedComponents/Fields/FieldParams/Types/Text.vue';
import NumberParameter from 'SharedComponents/Fields/FieldParams/Types/Number.vue';
import BooleanParameter from 'SharedComponents/Fields/FieldParams/Types/Boolean.vue';
import DateParameter from 'SharedComponents/Fields/FieldParams/Types/Date.vue';
import DateRestrictionParameter from 'SharedComponents/Fields/FieldParams/Types/DateRestriction.vue';
import CatalogParameter from 'SharedComponents/Fields/FieldParams/Types/Catalog.vue';
import OptionsParameter from 'SharedComponents/Fields/FieldParams/Types/Options.vue';
import FileParameter from 'SharedComponents/Fields/FieldParams/Types/File.vue';
import SelectParameter from 'SharedComponents/Fields/FieldParams/Types/Select.vue';
import GeolocationParameter from 'SharedComponents/Fields/FieldParams/Types/Geolocation.vue';
import WysiwygParameter from 'SharedComponents/Fields/FieldParams/Types/Wysiwyg.vue';
import ArrayOfParameter from 'SharedComponents/Fields/FieldParams/Types/ArrayOf.vue';
import TableColumnsParameter from 'SharedComponents/Fields/FieldParams/Types/TableColumns.vue';
import TableRowsParameter from 'SharedComponents/Fields/FieldParams/Types/TableRows.vue';

interface Props extends PropValue {
  parameter: FieldParameter;
  readonly?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'ParameterInput' },
  __name: 'ParameterInput',
  props: {
    parameter: {},
    readonly: { type: Boolean, default: false },
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {



const props = __props;
const emits = __emit;
const { innerValue } = useValue(props, emits);
const { NotEmpty } = useValidation();

const paramsMap = {
  text: TextParameter,
  textarea: TextParameter,
  number: NumberParameter,
  boolean: BooleanParameter,
  date: DateParameter,
  dateRestriction: DateRestrictionParameter,
  catalog: CatalogParameter,
  options: OptionsParameter,
  file: FileParameter,
  select: SelectParameter,
  geolocation: GeolocationParameter,
  wysiwyg: WysiwygParameter,
  arrayOf: ArrayOfParameter,
  tableColumns: TableColumnsParameter,
  tableRows: TableRowsParameter,
};
const type = computed(() => props.parameter.type);
const supported = computed(() => Object.keys(paramsMap).includes(type.value as string));
const required = computed(() => !props.parameter.isOptional);
const options = computed(() => {
  let baseProps: Record<string, any> = {
    label: props.parameter.label,
    readonly: props.readonly,
  };
  const rules = baseProps.rules || [];

  if (toValue(required)) {
    rules.push(NotEmpty());
  }

  if (props.parameter.rules) {
    rules.push(...props.parameter.rules);
  }
  if (props.parameter.description) {
    baseProps.description = props.parameter.description;
  }

  if (['text', 'textarea'].includes(type.value as string)) {
    baseProps.textarea = type.value === 'textarea';
  } else if (type.value === 'select') {
    baseProps.options = props.parameter.selectOptions;
  } else if (type.value === 'arrayOf') {
    baseProps.itemType = props.parameter.itemType;
  }

  if (props.parameter.extra) {
    baseProps = { ...baseProps, ...props.parameter.extra };
  }

  return { ...baseProps, rules };
});

return (_ctx: any,_cache: any) => {
  return (supported.value)
    ? (_openBlock(), _createBlock(_resolveDynamicComponent(paramsMap[type.value]), _mergeProps({ key: 0 }, options.value, {
        modelValue: _unref(innerValue),
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
          _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
        ],
        class: ["s-input s-input--dense", { 's-input--required': required.value }]
      }), null, 16, ["modelValue", "class"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, "Данный тип параметра (" + _toDisplayString(_ctx.parameter.type) + ") пока не поддерживается", 1))
}
}

})